import React from 'react';
import { Row, Col } from 'react-bootstrap';

const DwriManagementInfo = ({ sizingInfo, loading, error }) => {
    if (error) return <p className="text-danger">Error loading management data.</p>;
    if (loading && !sizingInfo) return <p>Loading...</p>;

    return (
        <>
            <Row>
                <Col>
                    <span><b>Assigned To: </b></span>
                    <span>{sizingInfo?.engineerName || ''}</span>
                    <br />
                    <span><b>CAA Date: </b></span>
                    <span>{sizingInfo?.ccaDate || 'No CCA'}</span>
                    <br />
                    <span><b>PWS Engineering Report: </b></span>
                    <span>{sizingInfo?.engReport || 'No'}</span>
                </Col>
                <Col>
                    <span><b>Plan Review File #: </b></span>
                    <span>{sizingInfo?.fileNumber || ''}</span>
                </Col>
                <Col>
                    <span><b>Standard Set: </b></span>
                    <span>{sizingInfo?.standardSet || ''}</span>
                    <br />
                    <span><b>Peak Day Demand per ERC (gal/day): </b></span>
                    <span>{sizingInfo?.peakDayDemand || ''}</span>
                    <br />
                    <span><b>Average Annual Demand per ERC (gal/day): </b></span>
                    <span>{sizingInfo?.averageAnnualDemand || ''}</span>
                    <br />
                    <span><b>Equalization Storage (gal): </b></span>
                    <span>{sizingInfo?.equalizationStorage || ''}</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span><i>Assumptions: 325851 gal/ACFT</i></span>
                </Col>
            </Row>
        </>
    );
};

export default DwriManagementInfo;
